<template>
<div class="value-progress">
  <progress-bar :percentage="value" :isMini="true"></progress-bar><span class="progress-percentage">{{value.toFixed(0)}}%</span>
</div>
</template>
<script>
import ProgressBar from '@/components/helpers/DataDisplay/ProgressBar'
export default {
  props: ['item', 'column', 'model'],
  components: { ProgressBar },
  computed: {
    value(){
      return parseFloat(eval('this.item.' + this.column.name)) * 100
    }
  }
}
</script>
<style lang="scss">
.value-progress{
  display: flex;
  .progress-bar-container{
    flex-grow: 8;
    align-self: center;
    max-width: 170px;
    .progress-bar{
      margin-bottom: 0;
    }
  }
  .progress-percentage{
    text-align: right;
    padding-left: 0.5em;
    align-self: center;
    display: inline-block;
    width: 45px;
    font-size: 12px;
    color: $ink-lighter;
  }
}
</style>



// WEBPACK FOOTER //
// CollectionValueProgress.vue?0367dc25